export default __webpack_public_path__ + "d72809cab870ac2eccc41e831a967603.png";